/* import __COLOCATED_TEMPLATE__ from './conversation-tags-over-time.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
/* eslint-disable ember/require-computed-property-dependencies */
/* eslint-disable ember/use-brace-expansion */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';

const allConversationsQueryReporting = {
  name: 'default_query',
  document_type: 'conversation',
  range_field: 'first_user_conversation_part_created_at',
  aggregation_type: 'value_count',
  aggregation_field: 'conversation_id',
};

export default Component.extend({
  appService: service(),
  app: readOnly('appService.app'),

  tooltipText: computed('baseQuery', function () {
    return { [this.baseQuery.key]: 'tagged conversations' };
  }),
  allConversationsQuery: allConversationsQueryReporting,

  conversationsQuery: computed('baseQuery', function () {
    return { ...this.baseQuery.query, nested_keys_are_dates: false };
  }),
  summaryValueComponent: computed('this.linkAction', function () {
    return this.linkAction
      ? 'reporting/element/conversations-link-summary-value'
      : 'reporting/element/summary-value';
  }),
});
